import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { CustomFields, Lci3DimensionTableData } from '@features/lci-report';
import { rsaDimensionsTableSlide } from '@features/lci-report/subdomains/visitation/slides/sales-attribution/rsa-dimensions-table-slide';
import { DEFAULT_SLIDE_MASTER, Slide } from '@features/powerpoint';
import { renderTableWithSubdimensions } from '../components/render-table';

const SUBDIMENSIONS_PER_SLIDE = 8;

export const salesAttributionTableSlides = (
  overallVisitMetrics: NonNullable<Lci3Report['visitMetrics']>,
  overallSalesMetrics: NonNullable<Lci3Report['salesMetrics']>,
  dimensionTableData: Lci3DimensionTableData,
  customFields: CustomFields
): Slide[] =>
  renderTableWithSubdimensions(
    dimensionTableData,
    SUBDIMENSIONS_PER_SLIDE,
    ({ subdimensions, dimensionName, dimensionSlug, page, totalPages }) => {
      const customField =
        customFields.dimensions[
          dimensionSlug as keyof CustomFields['dimensions']
        ];
      const slideHeader =
        customField && customField.salesTableHeader.length > 0
          ? customField.salesTableHeader
          : `Sales Attribution Summary Table - By ${dimensionName} (${page}/${totalPages})`;

      return rsaDimensionsTableSlide({
        slideMaster: DEFAULT_SLIDE_MASTER,
        subdimensions,
        overallSalesMetrics,
        slideHeader,
        overallVisitMetrics,
      });
    }
  );
